<template>
    <div class="w-[90%] max-w-md h-auto bg-white rounded-xl shadow-lg flex flex-col items-center overflow-hidden">

        <div class="w-11/12 text-center px-3 py-3">
            <p v-if="preTitle" class="text-base font-semibold font-sans text-gray-800 text-center">
                {{ preTitle }}
            </p>

            <h1 v-if="mainTitle" :class="['text-3xl font-bold font-sans my-1' , 'text-'+ brandTheme +'-primary']">
                {{ mainTitle }}
            </h1>

            <p v-if="subTitle" :class="['text-base font-semibold font-sans text-center ' , 'text-'+ brandTheme +'-dark']" :dir="direction">
                <span>
                    {{ subTitle }}
                    <img v-if="route.name === 'spin'" src="gifty.png" class="inline-block h-4 ml-1 align-text-bottom"
                        alt="">
                </span>
            </p>
        </div>

        <div class="w-full p-6" :dir="direction">
            <slot></slot>
        </div>

        <LocalityController />
    </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import LocalityController from './localityController.vue';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useParticipationStore } from '@/stores/useParticipationStore';


const participationStore = useParticipationStore();


const { t, locale } = useI18n();
const route = useRoute();

const direction = computed(() => (locale.value === 'fr' ? 'ltr' : 'rtl'));

// Hide all titles on celebration (or anything else you want)
const hideTitles = computed(() => route.name === 'celebration');

const preTitle = computed(() => {
    if (hideTitles.value) return '';
    if (route.name === 'photo' || route.name === 'phone') {
        return t('welcome.preTitle');
    }
    return '';
});

const mainTitle = computed(() => {
    if (hideTitles.value) return '';

    if (route.name === 'spin') {
        return t('spin.label');
    }

    return t('welcome.title');
});

const subTitle = computed(() => {
    if (hideTitles.value) return '';

    if (route.name === 'spin') {
        return t('spin.subtitle');
    }

    return t('welcome.subtitle');
});

const brandTheme = ref('');


onMounted(() => {
brandTheme.value = participationStore.participation?.brand ?? "cocacola";
    
})
</script>
